import { VCombobox } from 'vuetify/lib/components/VCombobox';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VCombobox,{attrs:{"deletable-chips":"","hide-details":"","items":_vm.items,"label":"Stands","multiple":"","small-chips":"","clearable":"","dense":"","flat":"","hide-no-data":"","outlined":""},model:{value:(_vm.selectedStands),callback:function ($$v) {_vm.selectedStands=$$v},expression:"selectedStands"}})
}
var staticRenderFns = []

export { render, staticRenderFns }